import React from 'react';
import { Card, Typography, Button, Image, Grid, Divider } from 'antd';
import '../../../Styles/Linkages&Outreach.css';
import image from "../../../Assets/Linkages/IC-Circular.jpg"
import { Link } from 'react-router-dom';

const { Title, Paragraph } = Typography;
const { useBreakpoint } = Grid;


const InternationalConferences = () => {
  const screens = useBreakpoint();

  return (
    <div className="training-workshops-container">
      <Card className="training-workshops-card" bordered={false} bodyStyle={{ padding: '40px' }}>
        <div className="content-wrapper">
       
          <div className="text-section">
            <Title level={2} className="section-title">
International Conferences
            </Title>
            <Divider className="ncgsa-divider" />
            <Paragraph style={{
            fontSize: screens.xs ? '14px' : screens.sm ? '20px' : screens.lg ? '125px' : '25px',
            lineHeight: screens.xs ? '1.5' : '1.8',
            textAlign: 'justify',
            color: 'black' // Optional: custom color
          }} className="description">


NCGSA convenes high-impact international conferences as part of its commitment to advancing global dialogue, innovation, and collaboration in the fields of space science technology and its applications. These flagship events serve as premier platforms for knowledge sharing, policy discourse, and interdisciplinary engagement bringing together scientists, researchers, industry leaders, and academicians from around the world. By enabling the exchange of cutting-edge research, breakthrough technologies, and visionary ideas, NCGSA’s international conferences contribute to shaping the future of space applications and building a globally connected space community.         </Paragraph>
            <Link to="/international-conferences">
              <Button className="view-all-btn" type="primary" shape="round">
                View All
              </Button>
            </Link>
          </div>
             <div className="image-section">
            <Image
            preview={false}
              src={image} // Replace with actual image path
              alt="Training Workshops"
              className="program-image"
            />
          </div>
        </div>
      </Card>
    </div>
  );
};

export default InternationalConferences;
